import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles'
import compose from 'recompose/compose'
import Grid from '../../common/components/Grid'
import Typography from 'material-ui/Typography'
import TextField from 'material-ui/TextField'
import Dialog, {DialogContent, withMobileDialog} from 'material-ui/Dialog'
import Divider from 'material-ui/Divider'
import {Link} from 'react-router-dom'
import IconButton from 'material-ui/IconButton'
import CloseIcon from 'material-ui-icons/Close'
import FacebookLoginButton from 'react-facebook-login'
import LoadingButton from '../../common/components/LoadingButton'
import {push} from 'react-router-redux'

import {signup as text} from './text'
import {connect} from 'react-redux'
import {
  Signup as SignupHandler,
  FacebookLogin,
} from '../../state/login/actions'
import styles from './styles'
import actions from '../signup/actions/signup'
import loginActions from '../login/actions/login'
import MaskedInput from 'react-text-mask'
import {FormControl, InputLabel} from 'material-ui'
import Input from 'material-ui/Input'

class Signup extends React.Component {

  handleSignInClick = (e) => {
    e.preventDefault()
    this.props.handleSignInClick()
  }

  handleLoginClick = () => {
    this.props.close()
    this.props.removeURL()
    this.props.handleLoginClick()
  }

  renderTerms = (classes) => (
    <Typography variant="caption" className={classes.terms}>
      {text.termsPart1}<Link to="https://space,guru/terminos" target="_blank">{text.termsPart2}</Link>
    </Typography>
  )

  render() {
    const {classes, fullScreen, open, close, removeURL} = this.props
    return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={close}
        maxWidth={'xs'}
        fullWidth
        classes={{
          paper: classes.Dialog,
        }}
      >
        <form noValidate autoComplete="off">
          <DialogContent>
            <IconButton className={classes.closeButton} onClick={() => {
              close()
              removeURL()
            }}><CloseIcon/></IconButton>
            <div style={{textAlign: 'center', marginTop: 80}}>
              <img src="/assets/logo.png" width={42} height={42} className={classes.logo} alt="logo"/>
            </div>
            <Grid container justify="center" direction="column" alignItems="center" className={classes.grid}>
              <Grid item xs={12} safariFix={true}>
                <Typography variant="title">{text.welcome}</Typography>
              </Grid>
              <Grid item xs={12} safariFix={true}>
                <Typography variant="body1" align={'center'}>
                  <span style={{color: '#5B687C'}}>{text.itsSimple}</span>
                </Typography>
                <Typography variant="body1" align={'center'}>
                  <span style={{color: '#5B687C'}}>{text.iHaveAnAccount} </span>
                  <span className={classes.link} onClick={this.handleLoginClick}>{text.thenSignIn}</span>
                </Typography>
              </Grid>
              <Grid item xs={12} safariFix={true} style={{paddingTop: 30}}>
                <LoadingButton
                  variant="primary"
                  isLoading={this.props.facebookIsFetching}
                  className={classes.button}
                  component="div"
                  style={{width: 280, backgroundColor: '#2160BE'}}
                >
                  <FacebookLoginButton
                    appId="1762190754086991"
                    fields="name,email"
                    reAuthenticate={false}
                    callback={this.props.handleFacebookSignIn}
                    cssClass={classes.facebookButton}
                    textButton={text.loginWithFacebook}
                    disableMobileRedirect={true}
                    tag="div"
                  />
                </LoadingButton>
              </Grid>
              {
                this.props.facebookError !== '' &&
                <Grid item xs={12} safariFix={true}>
                  <Typography className={classes.error}>{this.props.facebookError}</Typography>
                </Grid>
              }
              <Grid item xs={12} safariFix={true} style={{paddingTop: 30, paddingBottom: 10}}>
                <div className={classes.separator}>
                  <Divider className={classes.divider}/>
                  <Typography align="center" className={classes.o}> {text.or} </Typography>
                  <Divider className={classes.divider}/>
                </div>
              </Grid>
              <Grid item xs={12} safariFix={true}>
                <TextField
                  id="name"
                  label={text.labelName}
                  autoCorrect={false}
                  className={classes.textField}
                  error={this.props.nameError !== ''}
                  helperText={this.props.nameError}
                  onChange={e => this.props.setName(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} safariFix={true}>
                <TextField
                  id="email"
                  label={text.labelLastName}
                  className={classes.textField}
                  autoCorrect={false}
                  error={this.props.lastNameError !== ''}
                  helperText={this.props.lastNameError}
                  onChange={e => this.props.setLastName(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} safariFix={true}>
                <FormControl className={classes.textField}>
                  <InputLabel htmlFor="phone">{text.labelPhone}</InputLabel>
                  <Input
                    id="phone"
                    type="tel"
                    autoCorrect={false}
                    value={this.props.phone}
                    onChange={e => this.props.setPhone(e.target.value)}
                    inputComponent={TextMaskCustom}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} safariFix={true}>
                <TextField
                  id="email"
                  label={text.labelEmail}
                  className={classes.textField}
                  type="email"
                  error={this.props.emailError !== ''}
                  helperText={this.props.emailError}
                  onChange={e => this.props.setEmail(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} safariFix={true}>
                <TextField
                  id="password"
                  type="password"
                  label={text.labelPassword}
                  autoComplete="new-password"
                  className={classes.textField}
                  error={this.props.passwordError !== ''}
                  helperText={this.props.passwordError}
                  onChange={e => this.props.setPassword(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} safariFix={true}>
                <Typography className={classes.error}>{this.props.error}</Typography>
              </Grid>
              <Grid item xs={12} safariFix={true}>
                <LoadingButton
                  variant="primary"
                  isLoading={this.props.isFetching}
                  className={classes.button}
                  onClick={this.handleSignInClick}
                  type="submit"
                >
                  {text.button}
                </LoadingButton>
              </Grid>
              <Grid item xs={12} safariFix={true}>{this.renderTerms(classes)}</Grid>
            </Grid>
          </DialogContent>
        </form>
      </Dialog>
    )
  }
}

Signup.propTypes = {
  email: PropTypes.string,
  emailError: PropTypes.string,
  password: PropTypes.string,
  passwordError: PropTypes.string,
  phone: PropTypes.string,
  phoneError: PropTypes.string,
  isFetching: PropTypes.bool,
  error: PropTypes.string,
  facebookIsFetching: PropTypes.bool,
  facebookError: PropTypes.string,
  handleSignInClick: PropTypes.func,
  handleFacebookSignIn: PropTypes.func,
  removeURL: PropTypes.func
}

const mapStateToProps = state => {
  const dialog = state.ui.signupComponent.signup
  const login = state.ui.login
  return {
    email: login.signup.email,
    emailError: login.signup.emailError,
    name: login.signup.name,
    nameError: login.signup.nameError,
    lastName: login.signup.lastName,
    lastNameError: login.signup.lastNameError,
    phone: login.signup.phone,
    phoneError: login.signup.phoneError,
    password: login.signup.password,
    passwordError: login.signup.passwordError,
    isFetching: login.signup.isFetching,
    error: login.signup.error,
    facebookIsFetching: login.facebookLogin.isFetching,
    facebookError: login.facebookLogin.error,
    open: dialog.get('open'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setEmail: email => dispatch(SignupHandler.setEmail(email)),
    setName: name => dispatch(SignupHandler.setName(name)),
    setLastName: lastName => dispatch(SignupHandler.setLastName(lastName)),
    setPhone: phone => dispatch(SignupHandler.setPhone(phone)),
    setPassword: password => dispatch(SignupHandler.setPassword(password)),
    handleSignInClick: () => dispatch(SignupHandler.signup()),
    handleFacebookSignIn: response => dispatch(FacebookLogin.login(response)),
    handleLoginClick: () => dispatch(loginActions.open()),
    close: () => {
      dispatch(actions.close())
    },
    removeURL: () => {
      dispatch(push('/micatalogo'))
    }
  }
}

const Container = connect(mapStateToProps, mapDispatchToProps)(Signup)
const StyledSignup = compose(withStyles(styles, {withTheme: true}), withMobileDialog())(Container)

export default StyledSignup

const TextMaskCustom = ({inputRef, ...other}) => (
  <MaskedInput
    {...other}
    ref={inputRef}
    mask={['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
    placeholderChar={'\u2000'}
    showMask={false}
  />
)



// WEBPACK FOOTER //
// ./src/sections/signup/Signup.js